import { toast } from "react-toastify";
import axiosInstance from "../axiosInstance";
import APIPaths from "../../utils/APIPaths";

export const getOrgDetails = async () => {
  const response = await axiosInstance.get(APIPaths.GET_ORGANIZATION_DATA);

  if (response.status === 200) {
    toast.success(response.message);
    return response;
  } else {
    toast.error(response?.response?.data);
    return response;
  }
};

export const changeUserPasswordService = async (bodyObj) => {
  try {
    const response = await axiosInstance.post(
      APIPaths.CHANGE_USER_PASSWORD,
      bodyObj,
    );

    if (response.status === 200) {
      toast.success(response.data.message);
      return response;
    }
  } catch (error) {
    if (error.response?.data?.errors?.newPassword) {
      toast.error(error.response?.data?.errors?.newPassword);
    } else {
      toast.error(error.response?.data?.message);
    }
    return;
  }
};

export const getLoggedInUserDetails = async () => {
  const response = await axiosInstance.get(APIPaths.GET_LOGGED_IN_USER_DETAILS);

  if (response.status === 200) {
    toast.success(response.message);
    return response;
  } else {
    toast.error(response?.response?.data);
    return response;
  }
};
